import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { PpsUtilityService } from '../services/pps-utility.service';
import * as _ from 'lodash-es';
import { IRosterEmployeeNote } from '../shared/models/roster/roster-employee-note';
import { format } from 'date-fns';
import { RosterService } from '../services/roster.service';

@Component({
  selector: 'pps-roster-employee-note-form',
  templateUrl: './roster-employee-note-form.component.html'
})
export class RosterEmployeeNoteFormComponent implements OnInit{
  employeeName:string = "";
  subtitle: string = "";
  updateInfo: string = "";
  rosterEmployeeNote: IRosterEmployeeNote = null;
  oldRosterEmployeeNote: IRosterEmployeeNote = null;

  constructor(
    private _dialogRef: DynamicDialogRef,
    private _dialogConfig: DynamicDialogConfig,
    private _rosterService: RosterService,
    private _util: PpsUtilityService) {
  }

  ngOnInit(): void {
    this.setData(this._dialogConfig.data);
  }

  setData(empNote:IRosterEmployeeNote){
    this.rosterEmployeeNote = _.cloneDeep(empNote);
    this.oldRosterEmployeeNote = _.cloneDeep(empNote);
    this.updateInfo = "";
    this.subtitle = "Note on " + this._rosterService.getColumnName(empNote.columnName);
    if (this.rosterEmployeeNote.updateBy){
      this.updateInfo = `Last updated by ${this.rosterEmployeeNote.updateBy} on ${format(this.rosterEmployeeNote.updateDate, "dd/MM/yyyy HH:mm:ss")}`;
    }
  }

  hasFormChanged(): boolean{
    if (this.oldRosterEmployeeNote.note?.trim() === this.rosterEmployeeNote.note?.trim()){
      return false;
    }

    return true;
  }
  
  save(form: NgForm){
    if (form.invalid){
      return false;
    }

    this._dialogRef.close(this.rosterEmployeeNote);
  }

  cancel(){
    this._dialogRef.close(null);
  }
}
